import Joi from '@hapi/joi'

export const CashPluckingRateMappingListingSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    estate: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Operation Entity required`,
    }),
    divisionID: Joi.number().invalid(0).required().label("Collection Point").messages({
        "any.invalid": `Collection Point required`,
    }),
    jobTypeID: Joi.number().invalid(0).required().label("Job Type").messages({
        "any.invalid": `Job Type required`,
    }),

}

export const CashPluckingRateMappingAddEditSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group required`,
    }),
    estate: Joi.number().invalid(0).required().label("Operation Entity").messages({
        "any.invalid": `Operation Entity required`,
    }),

    cashWorkTypeID: Joi.number().invalid(0).required().label("Cash Work Type").messages({
        "any.invalid": `Cash Work Type is required`,
    }),
    divisionID: Joi.number().invalid(0).required().label("Collection Point").messages({
        "any.invalid": `Collection Point required`,
    }),
    jobTypeID: Joi.number().invalid(0).required().label("Job Type").messages({
        "any.invalid": `Job Type required`,
    }),
    rate: Joi.number().greater(0).required().label("Rate").messages({
        "number.greater": `Rate required`,
        "any.required": `Rate required`,
    }),
    fromDate: Joi.string().invalid("").required().label("From Date").messages({
        "any.required": `From Date required`,
    }),

}














